import { Box, Grid, Typography } from '@mui/material';
import React from 'react'
import Images from '../../../assets';

const TestScores = (props: any) => {
  console.log(props)
  return (
    <div>
      <Typography>Test scores</Typography>
      {props.data?.length > 0
        ? props.data.map((item: any, i: number) => (
          <Grid
            container
            sx={{ boxShadow: 3, p: 2, borderRadius: "10px" }}
            key={i}
          >
            <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      minWidth: 150,
                      color: "#7C7A7A",
                      fontSize: "14px",
                    }}
                  >
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{item?.name}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {
              item?.scores?.map((data:any, index:number) => (
                <Grid item xs={6} sx={{ display: "flex", p: 1 }}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography
                        sx={{
                          minWidth: 150,
                          color: "#7C7A7A",
                          fontSize: "14px",
                        }}
                      >
                        {data?.description}

                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>{data?.count}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))
            }
 <Grid item xs={6}>
              <Grid container>
                <Grid item xs={8}>
                  <Typography
                    sx={{
                      minWidth: 150,
                      color: "#7C7A7A",
                      fontSize: "14px",
                    }}
                  >
                    Took test on
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography >
                    {item?.testDate? item?.testDate?.slice(0, 10):"N/A"}{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container>
                <Grid item xs={8}>
                  <Typography
                    sx={{
                      minWidth: 150,
                      color: "#7C7A7A",
                      fontSize: "14px",
                    }}
                  >
                    Uploaded file
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                {item?.docId ?
                  <>
                  <iframe src={item?.docId?.preview_url} title="preview_url" style={{border:"none"}}/>
                {/* <img src={Images.pdfIcon} alt="" style={{ width: "1rem",marginRight:"10px" }} /> */}

                  {item?.docId?.FileName} 
                  </>
                
                  : 
                  <Typography>Not uploaded</Typography> }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))
        :
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            flexDirection: "column",
          }}
        >
          <img
            src={Images.noData}
            alt="noData"
            style={{ width: "70px", height: "70px", marginBottom: "1rem" }}
          />
          <Typography>No data </Typography>
        </Box>}
    </div>
  )
}

export default TestScores